import groq from 'groq';

export const localizedObjectiveCardsQuery = (locale: string) => groq`
  *[_type == "objectiveCards" && isActive == true][0] {
    _id,
    title,
    cards[] {
      title,
      description,
      icon {
        asset-> {
          _id,
          url,
          metadata {
            dimensions
          }
        },
        alt
      },
      position
    },
    isActive
  }
`;

export const objectiveCardsQuery = groq`
  *[_type == "objectiveCards" && isActive == true][0] {
    _id,
    title,
    description,
    cards[] {
      title,
      icon {
        asset-> {
          _id,
          url,
          metadata {
            dimensions
          }
        },
        alt
      },
      position
    },
    isActive
  }
`;
